export default __webpack_public_path__ + "static/media/notes_empty_state.128641af.svg";